import _styled from "styled-components";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import get from 'lodash/get';
import { darken, rem } from 'polished';
import PropTypes from 'prop-types';
import React from 'react';
import { createGlobalStyle } from 'styled-components';
import Box from './Box';
import theme from './theme';
const SpinCssKeyframes = createGlobalStyle(["@keyframes spin{from{transform:rotate(0deg);}to{transform:rotate(360deg);}}"]);
export const Button = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SpinCssKeyframes, null), /*#__PURE__*/React.createElement(_StyledBox, _extends({
  ref: ref,
  as: "button",
  tx: "buttons",
  variant: "default"
}, props, {
  __css: {
    appearance: 'none',
    display: props.block ? 'block' : 'inline-block',
    position: 'relative',
    textAlign: 'center',
    lineHeight: 'inherit',
    textDecoration: 'none',
    fontSize: getFontSize(props.size),
    fontWeight: 'bold',
    width: props.width || props.block ? '100%' : 'auto',
    px: getPadX(props.size),
    py: getPadY(props.size),
    border: 0,
    borderRadius: 'corner'
  },
  $_css: props.busy && `
        color: transparent;
        background-color: ${getBusyBackground(props.variant)}
        box-shadow: none;
        cursor: wait;
        &:hover {
          color: transparent;
          background-color: ${getBusyBackground(props.variant)}
        }
        &:before {
          animation: spin 1s linear infinite;
          display: block;
          width: ${rem(getSpinnerSize(props.size))};
          height: ${rem(getSpinnerSize(props.size))};
          position: absolute;
          border-width: ${rem(getSpinnerThickness(props.size))};
          border-style: solid;
          left: calc(50% - ${rem(getSpinnerSize(props.size) / 2)});
          top: calc(50% - ${rem(getSpinnerSize(props.size) / 2)});
          content: '';
          border-radius: 50%;
          background-clip: padding-box;
        }
      `
}))));
const getFontSize = size => {
  switch (size) {
    case 'tiny':
      return rem(12);
    case 'small':
      return rem(14);
    case 'default':
      return rem(16);
    case 'large':
      return rem(20);
    default:
      return rem(16);
  }
};
const getPadX = size => {
  switch (size) {
    case 'tiny':
      return 1;
    case 'small':
      return 2;
    case 'default':
      return 3;
    case 'large':
      return 4;
    default:
      return 3;
  }
};
const getPadY = size => {
  switch (size) {
    case 'tiny':
      return 0;
    case 'small':
      return 1;
    case 'default':
      return 2;
    case 'large':
      return 3;
    default:
      return 2;
  }
};
const getSpinnerSize = size => {
  switch (size) {
    case 'tiny':
      return 10;
    case 'small':
      return 14;
    case 'default':
      return 20;
    case 'large':
      return 24;
    default:
      return 20;
  }
};
const getSpinnerThickness = size => {
  switch (size) {
    case 'tiny':
      return 2;
    case 'small':
      return 2;
    case 'default':
      return 3;
    case 'large':
      return 4;
    default:
      return 3;
  }
};
const getBusyBackground = variant => {
  switch (variant) {
    case 'primary':
    case 'primaryOutline':
      return darken(0.05, get(theme, 'colors.primary'));
    case 'secondary':
    case 'secondaryOutline':
      return darken(0.05, get(theme, 'colors.secondary'));
    case 'green':
    case 'greenOutline':
      return darken(0.05, get(theme, 'colors.green'));
    case 'red':
    case 'redOutline':
      return darken(0.05, get(theme, 'colors.red'));
    case 'white':
    case 'whiteOutline':
      return darken(0.05, get(theme, 'colors.white'));
    case 'default':
    default:
      return get(theme, 'colors.gray.5');
  }
};
Button.propTypes = {
  /** Span the full width of a parent */
  block: PropTypes.bool,
  /** Busy, loading, submitting, etc */
  busy: PropTypes.bool,
  /** Size of button */
  size: PropTypes.oneOf(['tiny', 'small', 'default', 'large']),
  /** Color/style */
  variant: PropTypes.oneOf(['default', 'primary', 'secondary', 'green', 'red', 'white', 'outline', 'primaryOutline', 'secondaryOutline', 'greenOutline', 'redOutline', 'whiteOutline'])
};
Button.displayName = 'Button';
export default Button;
var _StyledBox = _styled(Box).withConfig({
  displayName: "Button___StyledBox",
  componentId: "sc-1qalum7-0"
})(["", ""], p => p.$_css);